<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="Inventory: EOQ Calculator"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[33, 67]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <app-ag-grid [gridOptions]="ptGridOptions" class="flex-1 min-h-0"></app-ag-grid>
        <ng-template #ptButtonsCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="editStyle(row)">Edit Product Type</button>
        </ng-template>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <p-splitter class="grow w-full" layout="horizontal" styleClass="h-full" [panelSizes]="[60, 40]">
          <ng-template pTemplate>
            <div class="flex flex-col w-full h-full overflow-hidden">
              <app-ag-grid [gridOptions]="ptaGridOptions" [rowData]="ptaItems" [hasFooter]="false" class="flex-1 min-h-0"></app-ag-grid>
            </div>
          </ng-template>
          <ng-template pTemplate>
            <div class="flex flex-col w-full h-full overflow-hidden">
              <app-ag-grid [gridOptions]="prodGridOptions" [rowData]="prodItems" [hasFooter]="false" class="flex-1 min-h-0"></app-ag-grid>
            </div>
          </ng-template>
        </p-splitter>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button *ngIf="!this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-check" (click)="saveChanges()">
      <span>Save</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised ml-2" icon="pi pi-undo" (click)="cancelChanges()">
      <span>Undo</span>
    </button>
  </div>
</ng-template>
